export default "__VITE_ASSET__742fa6e8__"